<template>
  <div
    class="
      v-input
      k-filter-v-input k-filter-v-date
      v-text-field v-text-field--box v-text-field--enclosed
      v-input--hide-details
      theme--light
    "
  >
    <div class="v-input__control">
      <div class="v-input__slot">
        <div class="v-text-field__slot">
          <label
            aria-hidden="true"
            class="theme--light v-label v-label--active"
            >{{ filterLabel }}</label
          >
          <date-time-picker
            v-if="isDateTime"
            ref="dateInput"
            :value="value"
            class="sb-table-datetimepicker visible"
            :disabled="disabledInput"
            :show="showDatetimePicker"
            :format="dateTimeDisplayFormat"
            placeholder=""
            :popup-settings="{
              popupClass: 'table-filter-date-picker custom-date-filter-popup',
            }"
            :required="!disabledInput ? true : false"
            @change="handleDateChange"
            @close="handleDateTimeClose"
            @focus.stop
            @iconclick="handleDatetimeIconClick"
          />
          <date-picker
            v-else
            ref="dateInput"
            :value="value"
            :disabled="disabledInput"
            class="visible"
            :format="dateDisplayFormat"
            placeholder=""
            :popup-settings="{
              popupClass: 'table-filter-date-picker custom-date-filter-popup',
            }"
            :required="!disabledInput ? true : false"
            @change="handleDateChange"
            @focus.stop
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DatePicker, DateTimePicker } from '@progress/kendo-vue-dateinputs';

const dateFilterOperatorText = {
  eq: 'Date is exactly',
  lt: 'Date is before',
  gt: 'Date is after',
  week: 'Last 7 days',
  month: 'Last 30 days',
  quarter: 'Last 3 months',
  year: 'Last year',
};
const disableInputOperators = ['week', 'month', 'quarter', 'year'];
export default {
  name: 'CustomDateFilter',
  components: {
    DatePicker,
    DateTimePicker,
  },
  props: {
    filterObj: {
      type: Object,
      default() {
        return {};
      },
    },
    dateFormat: {
      type: String,
      default() {
        return '';
      },
    },
  },
  data() {
    return {
      value: null,
      filterLabel: 'Search',
      disabledInput: false,
      showDatetimePicker: false,
      validDate: true,
    };
  },
  computed: {
    dateDisplayFormat() {
      return 'MM/dd/yyyy';
    },
    dateTimeDisplayFormat() {
      return 'MM/dd/yyyy HH:mm:ss';
    },
  },
  watch: {
    filterObj: {
      handler(newVal) {
        this.filterLabel =
          dateFilterOperatorText[newVal.operator] || newVal.operator;
        if (disableInputOperators.includes(newVal.operator)) {
          this.value = null;
          this.disabledInput = true;
        } else {
          this.disabledInput = false;
          if (this.$refs.dateInput) this.$refs.dateInput.focus();
        }
        this.validateDate();
      },
      immediate: true,
    },
  },
  created() {
    this.isDateTime = /H|m|s|S|X/.test(this.dateFormat);
  },
  mounted() {
    this.value = this.filterObj.value ? new Date(this.filterObj.value) : null;
  },
  methods: {
    getElementClassName(elem) {
      if (!elem) return '';
      if (typeof elem.className == 'string') return elem.className;
      return elem.className && elem.className.baseVal
        ? elem.className.baseVal
        : '';
    },
    getElementAriaLabel(elem) {
      return elem && elem.getAttribute
        ? elem.getAttribute('aria-label') || ''
        : '';
    },
    isSetAction(className, ariaLabel) {
      return className.includes('k-time-accept') || ariaLabel == 'Set time';
    },
    isInsideDateTimeContainer(className) {
      return (
        className.includes('k-datetime-container') ||
        className.includes('sb-table-datetimepicker')
      );
    },
    isCloseAction(elem, className, ariaLabel) {
      return (
        elem.tagName == 'BODY' ||
        className.includes('k-time-cancel') ||
        ariaLabel == 'Cancel'
      );
    },
    handleDateChange(e) {
      this.value = e.value;
      let filterObj = this.filterObj;
      filterObj.value = e.value;
      this.$emit('filter-change', filterObj);
      this.validateDate();
    },
    setValue() {
      this.value =
        this.filterObj.originalOperator &&
        disableInputOperators.includes(this.filterObj.originalOperator)
          ? null
          : this.filterObj.value
          ? new Date(this.filterObj.value)
          : null;
    },
    handleDatetimeIconClick() {
      if (this.showDatetimePicker) {
        this.hideDateTimePicker();
      } else {
        this.showDatetimePicker = true;
        document.body.addEventListener(
          'click',
          this.lookForDatetimeContainer,
          true
        );
      }
    },
    lookForDatetimeContainer(event, element) {
      const elem = element || event.target;
      const className = this.getElementClassName(elem);
      const ariaLabel = this.getElementAriaLabel(elem);
      // user clicked "Set" in time picker
      if (this.isSetAction(className, ariaLabel)) {
        setTimeout(() => {
          this.hideDateTimePicker();
        }, 0);
        return false;
      }
      // if the user clicks inside the container of the datetime picker
      if (this.isInsideDateTimeContainer(className)) {
        // do nothing
        return false;
      }
      // if the user clicked outside of the datetime container
      if (this.isCloseAction(elem, className, ariaLabel)) {
        // hide the datetime picker
        this.hideDateTimePicker();
        return false;
      }
      // recurse until we find the container of the body tag
      return this.lookForDatetimeContainer(event, elem.parentElement);
    },
    handleDateTimeClose() {
      // Keep controlled `show` prop in sync when Kendo closes the popup
      // via Set / Cancel / keyboard interactions.
      this.hideDateTimePicker();
    },
    hideDateTimePicker() {
      setTimeout(() => {
        const input = this.$el.querySelector(
          '.sb-table-datetimepicker .k-input-inner'
        );
        if (input) input.blur();
      }, 0);
      this.showDatetimePicker = false;
      // remove the event listener
      document.body.removeEventListener(
        'click',
        this.lookForDatetimeContainer,
        true
      );
    },

    validateDate() {
      let date = new Date(this.value),
        year = date.getFullYear();
      this.validDate = this.disabledInput
        ? true
        : this.value != null && year.toString().length == 4;
      this.$emit('valid-date', this.validDate);
    },
  },
};
</script>
<style lang="scss">
/* Active row indicator should be consistent across light and dark modes,
   and shared across all components that use CustomDateFilter. */
.custom-date-filter-popup .k-time-highlight,
.custom-date-filter-popup .k-time-list-highlight {
  border-top: 1px solid var(--blue) !important;
  border-bottom: 1px solid var(--blue) !important;
  border-left: 0 !important;
  border-right: 0 !important;
  border-color: var(--blue) !important;
  outline: 1px solid var(--blue) !important;
  outline-offset: -1px !important;
  background: transparent !important;
  pointer-events: none !important;
}

/* Keep text above the highlight frame so visibility is preserved in light mode. */
.custom-date-filter-popup .k-time-list-item,
.custom-date-filter-popup .k-time-list .k-item,
.custom-date-filter-popup .k-time-list li {
  background: transparent !important;
}

/* Remove Kendo time-wheel fade/gradient overlays in all modes for this popup. */
.custom-date-filter-popup .k-time-list-wrapper::before,
.custom-date-filter-popup .k-time-list-wrapper::after,
.custom-date-filter-popup .k-time-list::before,
.custom-date-filter-popup .k-time-list::after,
.custom-date-filter-popup .k-time-list-content::before,
.custom-date-filter-popup .k-time-list-content::after {
  background: none !important;
  background-image: none !important;
  box-shadow: none !important;
}

/* Fallback: style selected/focused list items directly if the shared highlight
   layer is not visibly rendered by the adaptive time picker. */
.custom-date-filter-popup .k-time-list .k-item[aria-selected='true'],
.custom-date-filter-popup .k-time-list-item[aria-selected='true'],
.custom-date-filter-popup .k-time-list .k-item.k-focus,
.custom-date-filter-popup .k-time-list-item.k-focus {
  border-top: 2px solid var(--blue) !important;
  border-bottom: 2px solid var(--blue) !important;
  background: rgba(37, 99, 235, 0.12) !important;
  box-shadow: inset 0 0 0 1px var(--blue) !important;
}

.custom-date-filter-popup .k-time-list-wrapper.k-focus .k-title,
.custom-date-filter-popup .k-time-list-wrapper.k-state-focused .k-title {
  color: var(--blue);
}

/* Dark mode fix for CustomDateFilter datetime popup.
   Popup is rendered in a portal under <body>, so selectors must be global. */
html.dark,
body.theme--dark {
  .custom-date-filter-popup .k-time-highlight,
  .custom-date-filter-popup .k-time-highlight span,
  .custom-date-filter-popup .k-time-highlight .k-time-selector,
  .custom-date-filter-popup .k-time-list-highlight {
    background: rgba(37, 99, 235, 0.22) !important;
    color: var(--text, #f1f5f9) !important;
    border-top: 2px solid var(--blue) !important;
    border-bottom: 2px solid var(--blue) !important;
    border-left: 0 !important;
    border-right: 0 !important;
    box-shadow: inset 0 0 0 1px var(--blue) !important,
      0 0 8px rgba(37, 99, 235, 0.35) !important;
  }

  .custom-date-filter-popup .k-button {
    color: var(--link-color, #60a5fa) !important;
    background: transparent !important;
  }

  .custom-date-filter-popup .k-time-list-wrapper.k-state-focused::before,
  .custom-date-filter-popup .k-time-list-wrapper.k-state-focused::after,
  .custom-date-filter-popup .k-time-list-wrapper.k-focus::before,
  .custom-date-filter-popup .k-time-list-wrapper.k-focus::after {
    background-color: transparent !important;
    border-color: transparent !important;
  }
}
</style>
